import { render, staticRenderFns } from "./ShoppingListModalContent.vue?vue&type=template&id=628d5b62&"
import script from "./ShoppingListModalContent.vue?vue&type=script&lang=js&"
export * from "./ShoppingListModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports